import { LocalDate } from 'js-joda';

import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { AdminDownloadRequest } = protos;

// Always fetch all invoices
const START = '2018-01-01';

export function fetchInvoices(): ApiAction {
  return {
    TockApi: {
      getListProto: `/reports/invoices?start_date=${START}&end_date=${LocalDate.now()}`,
      type: AppConstants.INVOICE_FETCH_ALL,
    },
  };
}

export function getDownloadToken(): ApiAction {
  return {
    TockApi: {
      postProto: '/download',
      request: AdminDownloadRequest.fromObject({ downloadType: 'INVOICE_PDF' }),
      type: AppConstants.DOWNLOAD,
    },
  };
}

export function getStripeDownloadUrl(invoice: dashboard.Invoice): ApiAction {
  return {
    TockApi: {
      getListProto: `/reports/invoice-url?processorId=${invoice.processorId}`,
      type: AppConstants.STRIPE_INVOICE_URL,
    },
  };
}
